import {EmptyProps, InitialEmptyProps} from "../empty/Empty.props";
import {UserDto} from "../../user/dto/User.dto";

export interface ListProps<T> {
    headers: ListHeader[],
    items: T[],
    emptyProps: EmptyProps,
    onCheckedChange: (seqs: number[]) => void
}

export const InitialListProps: ListProps<any> = {
    headers: [],
    items: [],
    emptyProps: InitialEmptyProps,
    onCheckedChange: (seqs: number[]) => {}
}

export interface ListPropsForUser<T> extends Omit<ListProps<T>, "onCheckedChange"> {
    onCheckedChange: (users: UserDto[]) => void,
}

export const InitialUserListProps: ListPropsForUser<any> = {
    headers: [],
    items: [],
    emptyProps: InitialEmptyProps,
    onCheckedChange: (users: UserDto[]) => {}
}

export interface ListHeader {
    type: ListColumnType,
    name: string,
    key: any,
    button?: ListButton,
    convertToString?: (...arg: any) => string,
    getCellStyle?: (arg: any) => {},
    paymentType?: (...arg: any) => string
}

export enum ListColumnType {
    NORMAL, LONG_TEXT, STATUS, CHECK_BOX, BUTTON, TOGGLE_BUTTON, ELLIPSIS
}

export const getColumnClass = (type: ListColumnType): string => {
    switch (type) {
        case ListColumnType.NORMAL :
        case ListColumnType.STATUS :
            return "";
        case ListColumnType.LONG_TEXT :
            return "long-text";
        case ListColumnType.CHECK_BOX :
            return "check-box";
        case ListColumnType.BUTTON :
            return "button";
        case ListColumnType.TOGGLE_BUTTON :
            return "header-toggle-button";
        case ListColumnType.ELLIPSIS :
            return "ellipsis";
    }
}

export interface ListButton {
    name: string,
    onClick: (...arg: any) => void
}